import styled from 'styled-components';

export const Container = styled.div`
	width: 100vw;
	max-width: 768px;
	min-height: 100dvh;
	margin: auto;
`;

export const Header = styled.header`
	width: 100%;
	position: sticky;
	top: 0px;
	background-color: ${({ theme }) => theme['white-primary']};
	z-index: 100;
`;

export const Content = styled.div<{ bottomHeight: number }>`
	padding-bottom: ${({ bottomHeight }) => `${bottomHeight}px`};
`;

export const Bottom = styled.div`
	width: 100%;
	max-width: 768px;
	position: fixed;
	bottom: 0px;
	z-index: 20;
`;

export const EmergencyPopup = styled.div`
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 10000;
	background-color: white;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	&::before {
		content: '';
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		position: absolute;
	}

	img {
		max-width: calc(100% - 45px);
		max-height: 70%;
		z-index: 10001;
	}
`;
